import { createContext, useState } from "react";

export const UpdateCartContext = createContext();

export const UpdateCartContextProvider = ({ children }) => {
  const [updateCart, setUpdateCart] = useState(false);

  return (
    <UpdateCartContext.Provider value={{ updateCart, setUpdateCart }}>
      {children}
    </UpdateCartContext.Provider>
  );
};
